import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import DocumentHtml from '@v2/shared/components/DocumentHtml';
import PageHeading from '@v2/shared/components/PageHeading';

export type Props = {
  /** The policy itself, from `includes/modules/legal/privacy/`. See below. */
  html: string;
};

/**
 * /privacy.
 *
 * The policy is not authored here, and must not be. Which one this page shows is decided
 * at request time: `privacyVersion`, a per-site option an administrator sets in
 * adminmagz, picks one of the dated documents in `includes/modules/legal/privacy/`, and
 * the same option is recorded against every order as the policy that customer agreed to.
 * Five versions are on disk and any of them can be made current without a deploy. So the
 * template renders whichever one is live and hands the markup over as a prop.
 */
export default function PrivacyPolicy({ html }: Props) {
  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'Privacy Policy' }]} />

      <PageHeading eyebrow="Customer Information">Our Privacy Policy</PageHeading>

      <ContentCard className="prose mt-6">
        <DocumentHtml html={html} />
      </ContentCard>
    </>
  );
}

PrivacyPolicy.layoutName = 'Layouts.Institutional';
